import apiService from '../apiService';

// 取得字段列表
export const getFields = async (params = {}) => {
    try {
        const query = { ...params };
        // 後端限制：page_size 最大 100
        if (query.page_size != null) {
            const n = Number(query.page_size);
            if (!Number.isNaN(n)) query.page_size = Math.min(n, 100);
            else delete query.page_size;
        }
        const response = await apiService.GET('api/admin/fields', query);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// 新增字段資料
export const createField = async (data) => {
    try {
        const response = await apiService.POST('api/admin/field', data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// 更新字段資料
export const updateField = async (id, data) => {
    try {
        const response = await apiService.PUT(`api/admin/field/${id}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// 刪除字段資料
export const deleteField = async (id) => {
    try {
        const response = await apiService.DELETE(`api/admin/field/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}; 